/** Stored before login so DeepLinkHandler can restore the intended path after auth. */
export const PENDING_POST_LOGIN_PATH_KEY = 'pendingDeepLinkPath';

export function stashPostLoginPath(path: string): void {
  try {
    localStorage.setItem(PENDING_POST_LOGIN_PATH_KEY, path);
  } catch {
    /* ignore quota / private mode */
  }
}
